module.exports = __webpack_public_path__ + "assets/logo2.9ac3923b.svg";